import { useState } from "react";

interface PlayerAvatarProps {
    playerId: number;
    teamId?: number;
    firstName?: string;
    lastName?: string;
    className?: string;
    imgClassName?: string;
    /** Use "dark" variant for white initials/silhouette on dark backgrounds */
    variant?: "light" | "dark";
}

function FallbackSvg({ initials, variant }: { initials: string; variant: "light" | "dark" }) {
    const fg = variant === "dark" ? "rgba(255,255,255,0.7)" : "rgba(5,0,102,0.5)";
    const bg = variant === "dark" ? "rgba(255,255,255,0.08)" : "rgba(5,0,102,0.07)";
    return (
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <rect width="100" height="100" fill={bg} />
            {/* Helmet */}
            <path
                d="M50 14 C36 14 28 24 28 36 C28 40 30 44 32 47 L32 52 L68 52 L68 47 C70 44 72 40 72 36 C72 24 64 14 50 14 Z"
                fill={fg}
            />
            {/* Visor */}
            <path d="M34 44 Q50 50 66 44 L66 48 Q50 55 34 48 Z" fill={variant === "dark" ? "rgba(255,255,255,0.15)" : "rgba(5,0,102,0.1)"} />
            {/* Neck */}
            <rect x="44" y="52" width="12" height="6" fill={fg} />
            {/* Shoulders/jersey */}
            <path d="M24 88 Q30 58 44 58 L56 58 Q70 58 76 88 Z" fill={fg} />
            {/* Initials */}
            <text
                x="50"
                y="80"
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="16"
                fontWeight="700"
                fontFamily="system-ui, sans-serif"
                fill={variant === "dark" ? "rgba(255,255,255,0.9)" : "rgba(5,0,102,0.8)"}
            >
                {initials}
            </text>
        </svg>
    );
}

export function PlayerAvatar({
    playerId,
    teamId,
    firstName = "",
    lastName = "",
    className = "",
    imgClassName = "w-full h-full object-cover",
    variant = "light",
}: PlayerAvatarProps) {
    const [failed, setFailed] = useState(false);

    const initials = `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase();
    const photoSrc = teamId != null ? `/${teamId}/${playerId}.avif` : null;

    if (!failed && photoSrc) {
        return (
            <img
                src={photoSrc}
                alt={`${firstName} ${lastName}`}
                className={imgClassName}
                onError={() => setFailed(true)}
            />
        );
    }

    return (
        <div className={`w-full h-full flex items-center justify-center ${className}`}>
            <FallbackSvg initials={initials} variant={variant} />
        </div>
    );
}
